export const FRONTEND_URL = process.env.NEXT_PUBLIC_FRONTEND_URL;
export const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL;
export const API_VERSION = process.env.NEXT_PUBLIC_API_VERSION;
